/**
 * İki parmak (pinch) zoom'u uygulama genelinde kapatır.
 *
 * Üç ayrı katman gerekiyor, çünkü hiçbiri tek başına tüm platformları kapsamıyor:
 *   1) public/index.html → user-scalable=no  : yalnız Android Chrome'da bağlayıcı.
 *   2) src/index.css     → touch-action      : modern dokunmatikte pinch + çift-dokunma zoom'u keser.
 *   3) bu dosya                              : iOS Safari (meta'yı yok sayar) ve
 *                                              masaüstü trackpad pinch'i (ctrl+wheel olarak gelir).
 *
 * iOS Safari 10'dan beri user-scalable=no'yu erişilebilirlik gerekçesiyle yok sayar;
 * oradaki tek yol WebKit'e özgü gesturestart/gesturechange/gestureend olaylarını iptal etmek.
 *
 * Masaüstünde trackpad pinch'i touch olayı üretmez; ctrlKey=true olan bir wheel olayı
 * olarak gelir — bu yüzden touch-action onu yakalamaz, ayrı dinleyici gerekir.
 */
export const disableZoom = () => {
    // iOS Safari: pinch jestinin kendisi
    const preventGesture = (e) => e.preventDefault()
    document.addEventListener('gesturestart', preventGesture, { passive: false })
    document.addEventListener('gesturechange', preventGesture, { passive: false })
    document.addEventListener('gestureend', preventGesture, { passive: false })

    // Masaüstü trackpad pinch + ctrl/cmd & fare tekerleği ile sayfa zoom'u
    document.addEventListener('wheel', (e) => {
        if (e.ctrlKey || e.metaKey) {
            e.preventDefault()
        }
    }, { passive: false })

    // Klavye ile zoom (Ctrl/Cmd + '+' / '-' / '0')
    document.addEventListener('keydown', (e) => {
        if ((e.ctrlKey || e.metaKey) && ['+', '-', '=', '_', '0'].includes(e.key)) {
            e.preventDefault()
        }
    }, { passive: false })
}
